import React, { useEffect, useRef, useState } from "react";
import api from "../api";
import { Col, Container, Row } from "shards-react";
import {
  Button,
  CircularProgress,
  createMuiTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MuiThemeProvider
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import FolderIcon from "@material-ui/icons/Folder";
import BuildIcon from "@material-ui/icons/Build";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px 8px 0px 8px",
          fontSize: "0.73rem"
        }
      },
      MuiFormLabel: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiInputBase: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiTypography: {
        body1: {
          fontSize: "0.75rem"
        }
      }
    }
  });

export const getColumns = () => [
  {
    name: "geodefender_id",
    label: "Id",
    options: {
      filter: false,
      sort: true,
      display: true
    }
  },
  {
    name: "state",
    label: "Estado",
    options: {
      filter: true,
      filterType: "dropdown",
      sort: true,
      display: true
    }
  },
  {
    name: "plate",
    label: "Patente",
    options: {
      filter: true,
      filterType: "dropdown",
      sort: true,
      display: true
    }
  },
  {
    name: "group",
    label: "Grupo empresa",
    options: {
      filter: true,
      filterType: "dropdown",
      sort: true,
      display: true
    }
  },
  {
    name: "act_number",
    label: "Número de acta",
    options: {
      filter: true,
      filterType: "dropdown",
      sort: true,
      display: true
    }
  },
  {
    name: "date",
    label: "Fecha",
    options: {
      filter: true,
      filterType: "dropdown",
      sort: true,
      display: true
    }
  },
  {
    name: "time",
    label: "Hora",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "reason",
    label: "Motivo",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "location",
    label: "Ubicación",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "jurisdiction",
    label: "Jurisdicción",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "total_fine",
    label: "Total multa",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "expiration_date",
    label: "Fecha vencimiento",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "description",
    label: "Descripción",
    options: {
      filter: false,
      display: true
    }
  },
  {
    name: "type",
    label: "Tipo",
    options: {
      filter: false,
      display: true
    }
  }
];

const getSelectedGeodefenderIds = (selectedRows, displayData) =>
  selectedRows.data.map(row => displayData[row.index].data[0]);

const GeodefenderFines = ({ match, client_id: clientIdProp }) => {
  const client_id =
    clientIdProp || (match && match.params && match.params.id) || null;
  const [geodefenderFines, setGeodefenderFines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [creatingWorkOrders, setCreatingWorkOrders] = useState(false);
  const clearSelectedRowsRef = useRef(null);
  const getGeodefenderFines = async () => {
    const token = localStorage.getItem("userToken");
    const url = api.geodefender_fines().index(client_id);
    return await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setGeodefenderFines(res.data.data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    setLoading(true);
    getGeodefenderFines();
  }, [client_id]);

  const handleCreateWorkOrders = async ids => {
    const token = localStorage.getItem("userToken");
    setCreatingWorkOrders(true);
    try {
      await axios.post(
        api.geodefender_fines().createWorkOrders(),
        { geodefender_ids: ids },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setConfirmDialogOpen(false);
      setSelectedIds([]);
      if (clearSelectedRowsRef.current) {
        clearSelectedRowsRef.current([]);
      }
      setLoading(true);
      await getGeodefenderFines();
    } catch (err) {
      console.log(err);
    } finally {
      setCreatingWorkOrders(false);
    }
  };

  const handleOpenCreateWorkOrdersDialog = (selectedRows, displayData) => {
    const ids = getSelectedGeodefenderIds(selectedRows, displayData);
    setSelectedIds(ids);
    setConfirmDialogOpen(true);
  };
  const options = {
    print: false,    
    responsive: "stacked",
    selectableRowsOnClick: false,
    selectableRows: true,
    download: false,
    textLabels: {
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
        downloadCsv: "Exportar XLS"
      },
      body: {
        noMatch: loading ? "No hay resultados" : <CircularProgress />
      },
      selectedRows: {
        text: "fila(s) seleccionadas"
      },
      viewColumns: {
        title: "Ver columnas"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de"
      },
      filter: {
        all: "Todos",
        title: "Filtros",
        reset: "Limpiar"
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Importar multas"}>
            <IconButton
              onClick={e => {
                window.location.href = "geodefender-fines/import";
              }}
            >
              <FolderIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      clearSelectedRowsRef.current = setSelectedRows;
      return (
        <React.Fragment>
          <div className="ml-2">
            <Tooltip title={"Crear OTs"}>
              <IconButton
                onClick={() =>
                  handleOpenCreateWorkOrdersDialog(selectedRows, displayData)
                }
              >
                <BuildIcon />
              </IconButton>
            </Tooltip>
          </div>
        </React.Fragment>
      );
    }
  };

  return (
    <div>
      <Dialog
        open={confirmDialogOpen}
        onClose={() => !creatingWorkOrders && setConfirmDialogOpen(false)}
        fullWidth
        aria-labelledby="create-work-orders-dialog-title"
        aria-describedby="create-work-orders-dialog-description"
      >
        <DialogTitle id="create-work-orders-dialog-title">
          Crear órdenes de trabajo
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="create-work-orders-dialog-description">
            ¿Está seguro de que desea crear {selectedIds.length} OT
            {selectedIds.length === 1 ? "" : "s"} para las multas seleccionadas?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmDialogOpen(false)}
            color="primary"
            variant="contained"
            disabled={creatingWorkOrders}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleCreateWorkOrders(selectedIds)}
            color="primary"
            variant="contained"
            autoFocus
            disabled={creatingWorkOrders}
          >
            {creatingWorkOrders ? <CircularProgress size={24} /> : "Continuar"}
          </Button>
        </DialogActions>
      </Dialog>
      {loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    title={
                      client_id
                        ? "Infracciones del cliente"
                        : "Lista de Multas Geodefender"
                    }
                    data={geodefenderFines}
                    columns={getColumns()}
                    options={options}
                  />
                </MuiThemeProvider>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};
export default GeodefenderFines;
